<script>
	import { onMount } from "svelte";
	// import Button from "smelte/src/components/Button";
	import { Button, Snackbar } from "smelte";
	import {
		LeafletMap,
		TileLayer,
		Marker,
		Tooltip,
		Circle,
	} from "svelte-leafletjs";
	import { filter, sortBy, throttle } from "lodash-es";
	// import { Slider } from "smelte";
	import Slider from "@fouita/slider";
	import dayjs, { tz } from "dayjs";
	import customParseFormat from "dayjs/plugin/customParseFormat";
	import timezone from "dayjs/plugin/timezone";
	import utc from "dayjs/plugin/utc";
	import { now } from "svelte/internal";

	dayjs.extend(customParseFormat);
	dayjs.extend(timezone);
	dayjs.extend(utc);

	const mapOptions = {
		center: [-33.84, 151.0824],
		zoom: 11,
	};
	const tileUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
	const tileLayerOptions = {
		minZoom: 0,
		maxZoom: 20,
		maxNativeZoom: 19,
		attribution: "© OpenStreetMap contributors",
	};

	let leafletMap;
	// dayjs.tz.setDefault("Australia/Sydney");
	let venues;
	let myAreaVisible = false;
	let circleLatLng = [];
	let buttonText = "Show my location";
	let buttonIcon = "person_pin_circle";

	let end_display = dayjs()
		.tz("Australia/Sydney")
		.format("ddd, D MMM YYYY")
		.toString();
	let start_display = dayjs()
		.tz("Australia/Sydney")
		.subtract(28, "day")
		.format("ddd, D MMM YYYY")
		.toString();
	let v = dayjs.unix().tz("Australia/Sydney").format("ddd, D MMM YYYY");
	let jsondata;
	let result = [];
	let showSnackbarTop = false;

	onMount(async () => {
		fetch(`data.json`)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				jsondata = data;
			});

		if (leafletMap) {
			console.log("map bounds and invalidate size");
			leafletMap.getMap().getBounds();
			leafletMap.getMap().invalidateSize();
			leafletMap.getMap().on("locationfound", function (e) {
				// toggleVisibility();
				circleLatLng = [e.latitude, e.longitude];
				// console.log("location found", myAreaVisible, e);
				toggleVisibility();
			});
			leafletMap.getMap().on("locationerror", function (e) {
				console.log(e);
				showSnackbarTop = true;
			});
		}
	});

	function searchData(data, startDate) {
		// console.log("startdate in searchdata", startDate);
		result = filter(data, function (row) {
			return (
				dayjs(row.StartTime) >= dayjs(startDate).startOf("day") &&
				dayjs(row.EndTime) < dayjs(startDate).endOf("day")
			);
		});
		// console.log("result inside searchdata", result);
		return result;
	}

	function showMe(start) {
		result = searchData(jsondata, start);
		result = sortBy(result, ["Date", "StartTime", "Venue"]);
	}

	function toggleVisibility() {
		// console.log("visibility toggled", myAreaVisible);
		myAreaVisible = !myAreaVisible;
		if (myAreaVisible === true) {
			buttonText = "Hide my location";
			buttonIcon = "location_off";
		} else {
			buttonText = "Show my location";
			buttonIcon = "person_pin_circle";
		}
	}

	function nearMe() {
		// console.log("inside near me", myAreaVisible);
		leafletMap.getMap().locate({ setView: true, maxZoom: 13 });
	}
</script>

<Snackbar color="alert" top bind:value={showSnackbarTop}>
	<div>Access to user's location denied.</div>
</Snackbar>

<main>
	<p class="text-primary-500 lg:text-xl sm:text-sm">
		Covenues19: NSW Case Locations
	</p>
	<small
		>Data Source: <a
			href="https://data.nsw.gov.au/data/dataset/nsw-covid-19-case-locations"
			target="_blank"
			class="underline">NSW Covid-19 Case Locations</a
		></small
	>
	<div class="pt-2 text-xs text-center">Drag Slider to Select Date:</div>

	<div class="lg:text-xl text-sm text-center">
		{dayjs
			.unix(v / 1000)
			.tz("Australia/Sydney")
			.format("ddd, D MMM YYYY")}
	</div>
	<div class="lg:px-20 px-1">
		<Slider
			class="mt-5 mx-2 mb-5 text-xs"
			min={dayjs()
				.startOf("day")
				.tz("Australia/Sydney")
				.subtract(28, "day")}
			max={dayjs().endOf("day").tz("Australia/Sydney")}
			step="86400000"
			color="primary-300"
			minLabel={dayjs()
				.startOf("day")
				.tz("Australia/Sydney")
				.subtract(28, "day")
				.format("D MMM YYYY")}
			maxLabel={dayjs()
				.startOf("day")
				.tz("Australia/Sydney")
				.format("D MMM YYYY")}
			bind:value={v}
			on:change={() => showMe(v)}
		/>
	</div>
	<div class="flex justify-center">
		<Button
			class="bg-primary-400 text-white active:bg-primary-800 font-bold uppercase text-xs px-1 mt-1 py-1 rounded shadow hover:shadow-md outline-none focus:outline-none ease-linear transition-all duration-150"
			type="button"
			on:click={nearMe}
			icon={buttonIcon}
		>
			{buttonText}</Button
		>
	</div>
</main>

<div class="example" style="width: 100%; height: 55%;">
	<LeafletMap bind:this={leafletMap} options={mapOptions}>
		<TileLayer url={tileUrl} options={tileLayerOptions} />
		{#if myAreaVisible === true}
			<Circle
				radius={1000}
				color="#00695f"
				fillColor="#33ab9f"
				bind:latLng={circleLatLng}
			/>
		{/if}
		{#each result as venue}
			<Marker latLng={[venue.Lat, venue.Lon]}>
				<Tooltip
					><strong>{venue.Venue}</strong> <br />
					{venue.Address}, {venue.Suburb} <br />
					{dayjs(venue.Date).format("ddd D MMMM YYYY")}
					<br />
					{dayjs(venue.StartTime).format("hh:mm A")} to {dayjs(
						venue.EndTime
					).format("hh:mm A")}
				</Tooltip>
			</Marker>
		{/each}
	</LeafletMap>
</div>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 360px;
		margin: 0 auto;
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>
